import React from 'react';
import styled from 'styled-components';
import CloseLineIcon from 'remixicon-react/CloseLineIcon';
import ErrorWarningLineIcon from 'remixicon-react/ErrorWarningLineIcon';

import IconButton from '../Button/IconButton';

type AlertSeverity = 'info' | 'warning' | 'error';

type AlertBannerProps = {
    message: string | undefined;
    severity?: AlertSeverity;
    onClose?: () => void;
};

const AlertBanner: React.FC<AlertBannerProps> = ({ message, severity = 'warning', onClose }) => {
    return (
        message && (
            <Container severity={severity}>
                <ContentWrapper>
                    <ErrorWarningLineIcon size="17" />
                    <AlertContent dangerouslySetInnerHTML={{ __html: message || '' }} />
                </ContentWrapper>
                <ButtonContainer>
                    <IconButton transparent onClick={() => onClose?.()}>
                        <CloseLineIcon size="17" />
                    </IconButton>
                </ButtonContainer>
            </Container>
        )
    );
};

const ContentWrapper = styled.div`
    display: flex;
    flex-direction: row;
    gap: 1rem;
    margin-left: auto;
    align-items: center;
`;

const AlertContent = styled.span`
    a {
        color: inherit;
        text-decoration: underline;
        font-weight: 500;

        &:hover {
            opacity: 0.8;
        }
    }

    strong,
    b {
        font-weight: 700;
    }
`;

const Container = styled.div<{ severity: AlertSeverity }>`
    background: ${props => {
        switch (props.severity) {
            case 'error':
                return props.theme.colors.error;
            case 'info':
                return props.theme.colors.info;
            case 'warning':
            default:
                return props.theme.colors.warning;
        }
    }};
    color: #1a1a1a;
    height: 3rem;
    padding: 1.5rem;
    display: flex;
    flex-direction: row;
`;

const ButtonContainer = styled.div`
    justify-content: flex-end;
    align-self: center;
    margin-left: auto;
`;

export default AlertBanner;
